namespace $.$$ {
	$mol_style_define( $shm_mentionstat_chart, {
		Tools: {
			position: 'absolute',
			top: '8px',
			right: '8px',
			zIndex: $mol_layer.hover,
		},
		Group_select: {
			width: 'fit-content',
			flex: { grow: 0, shrink: 0 },
			minHeight: 0,
			background: { color: $mol_theme.card },
		},
	} )
}
